import { NavigationService } from '../../../@vex/services/navigation.service';
import { Component } from '@angular/core';
import { LayoutService } from '../../../@vex/services/layout.service';
import { map } from 'rxjs/operators';
import { ConfigService } from '../../../@vex/services/config.service';
import { navigationItems } from './layout.constants';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { NavigationItem, NavigationLink } from 'src/@vex/interfaces/navigation-item.interface';

@Component({
  selector: 'aum-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent {
  sidenavCollapsed$ = this.layoutService.sidenavCollapsed$;
  isFooterVisible$ = this.configService.config$.pipe(
    map(config => config?.footer.visible)
  );
  isDesktop$ = this.layoutService.isDesktop$;

  constructor(
    private layoutService: LayoutService,
    private configService: ConfigService,
    private navigationService: NavigationService,
    private authService: AuthService
  ) {
    this.navigationService.items = this.filterNavItems(navigationItems);
  }

  private filterNavItems(items: NavigationItem[]): NavigationItem[] {
    return items
      .map(item => {
        if (item.type === 'subheading') {
          const filteredChildren = item.children.filter(child => {
            const privilege = (child as NavigationLink).requiredPrivilege;
            return !privilege || this.authService.hasPrivilege(privilege);
          });
          return { ...item, children: filteredChildren };
        }
        return item;
      })
      .filter(item => {
        if (item.type === 'subheading') {
          return item.children.length > 0;
        }
        if (item.type === 'link') {
          const privilege = (item as NavigationLink).requiredPrivilege;
          return !privilege || this.authService.hasPrivilege(privilege);
        }
        return true;
      });
  }
}
